/* global angular */
console.log('[gc version] ' + window.gcVersion);

angular.module('graphcomment', [
  'ngSanitize',
  'ngUpload',
  'ngTouch',
  'gc.ui.autoGrow',
  'gc.ui.textareaFocus',
  'gc.ui.contentselectable',
  'gc.ui.contenteditable',
  'gc.ui.smartEditPopup',
  'gc.ui.focus',
  'gc.fallback-avatar',
  'gc.progress-bar',
  'gc.ui.showMore',
  'ui.bootstrap.dropdown',
  'GraphCommentModule',
  'utils.scroll',
  'gc.filters',
  'gc.directives',
  'gc.services',
  'gc.share',
  'gc.perfs',
  'gc.readstatus',
  'gc.focus',
  'gc.sliders',
  'gc.askpopin',
  'gc.share-popin',
  'gc.profile-popin',
  'gc.account-popin',
  'gc.vote-popin',
  'gc.lang',
  'gc.localstorage',
  'gc.postmessage',
  'gc.emoticon',
  'gc.embed',
  'gc.utils',
  'gc.notifs',
  'gc.ws',
  'gc.custom-on-change',
  'gc.fileread',
  'gc.drop-upload',
  'gc.custom-scrollbar',
  'pascalprecht.translate',
  'angular-jwt',
  'xeditable',
  'bw.paging',
  '720kb.tooltips',
  'gc.pub',
  'gc.recaptcha'
])

.constant('DEBUG', true)

.factory('authInterceptor', [
'$rootScope',
'$q',
'LocalStorageService',
'API_URL',
'$injector',
'GraphLogin',
function ($rootScope, $q, LocalStorageService, API_URL, $injector, GraphLogin) {
  'use strict'; 

  function refreshToken(response) {
    var CommentService = $injector.get('CommentService');

    if (
      response.data &&
      response.data.gcCode === 410 &&
      response.data.msg === 'route need authentication' &&
      response.config.headers.Authorization
    ) { 
      var config = response.config;
      var $http = $injector.get('$http');
   
      if(CommentService && CommentService.website && !CommentService.website.sso.active){

        return GraphLogin.get().fetchGraphLogin('triggerRefreshToken').then((msg)=> {
          
          return $http(config)
        }).catch((error) => {
          GraphLogin.get().logout()
          return $q.reject(error);
        })
      }
      
    } else {
      return response || $q.when(response);
    }
  }

  return {
    request: function (config) {
      if (typeof config.url === 'string' && config.url.indexOf(API_URL) === 0) {
        config.headers = config.headers || {};
        var gc_token = LocalStorageService.getToken();
        // migration with store.js
        if (/^".*"$/.test(gc_token)) gc_token = gc_token.replace(/^"(.*)"$/, '$1');
        // if there's a token and no custom Authorization header defined
        if (gc_token) {
          config.headers.Authorization = gc_token;
        }
      }

      return config;
    },
    response: function (response) {
      return refreshToken(response)
    },

    responseError: function (responseError) {
      return refreshToken(responseError)   
    }
  };
}])

.config(['$httpProvider', function ($httpProvider) {
  'use strict';
  $httpProvider.interceptors.push('authInterceptor');

  // disable cache on IE11
  // (https://github.com/jhipster/generator-jhipster/issues/777#issuecomment-63853239)
  $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.cache = false;
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }
  $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';

}])

.config(['$qProvider', function ($qProvider) {
  $qProvider.errorOnUnhandledRejections(false);
}])

.config(['$rootScopeProvider', function($rootScopeProvider) {
  // to avoid digest infinite loop when displaying a thread with 10+ levels
  $rootScopeProvider.digestTtl(30);
}])


.config(['$provide', function ($provide) {

  // add back support to promise.success and promise.error
  // because they were deprecated, and it's too much work to
  // migrate our codebase.
  $provide.decorator('$http', ['$delegate', function ($delegate) {
    function extend(fn) {
      return function() {
        var promise = fn.apply(null, arguments);
        promise.success = function (fn) {
          promise.then(function(response) {
            fn(response.data, response.status, response.config);
          });
          return promise;
        };
        promise.error = function (fn) {
          promise.then(null, function(response) {
            fn(response.data, response.status, response.config);
          });
          return promise;
        };
        return promise;
      };
    };

    var extended = extend($delegate);
    angular.extend(extended, $delegate);
    ['get', 'delete', 'head', 'jsonp', 'post', 'put', 'patch'].forEach(method => {
      extended[method] = extend($delegate[method]);
    });

    return extended;
  }]);
}])

.config([
  '$translateProvider', 'DEFAULT_LANGUAGE', 'APP_LANGUAGES',
  function ($translateProvider, DEFAULT_LANGUAGE, APP_LANGUAGES)
{
  'use strict';
  $translateProvider.useStaticFilesLoader({
    prefix: 'lang/',
    suffix: '-' + window.langRev + '.json'
  });
  $translateProvider.useSanitizeValueStrategy(null);
  var availableLanguages = APP_LANGUAGES.map(lang => lang.value)
  $translateProvider.registerAvailableLanguageKeys(availableLanguages, {
    'en-*' : 'en',
    'fr-*' : 'fr',
    'zh-*' : 'zh',
    'es-*' : 'es',
    'pt-*' : 'pt',
    'it-*' : 'it',
    'cz-*' : 'cz',
    'fa-*' : 'fa',
    'en_*' : 'en',
    'fr_*' : 'fr',
    'zh_*' : 'zh',
    'es_*' : 'es',
    'pt_*' : 'pt',
    'cz_*' : 'cz',
    'fa_*' : 'fa',
    'uk_*' : 'uk',
    'tr_*' : 'tr',
    'ar-*': 'ar',
    'id-*': 'id',
    'hu-*': 'hu',
    'ca-*': 'ca',
    'sv-*': 'sv',
    'pl-*': 'pl',
    'nb-*': 'nb',
    'ro-*': 'ro',
  });

  // get the browser language
  var browserLang;
  ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'].forEach(function (property) {
    var language = window.navigator[property];
    if (language && language.length > 0) browserLang = language;
  });

  if (browserLang) browserLang = browserLang.slice(0, 2);

  $translateProvider.preferredLanguage(browserLang || DEFAULT_LANGUAGE);
}])

.config(['DEBUG', '$logProvider', function(DEBUG, $logProvider){
  'use strict';
  if (!DEBUG) {
    $logProvider.debugEnabled(false);
  }
}])

.config(['$compileProvider', function ($compileProvider) {
  $compileProvider.debugInfoEnabled(false);
}])

.config([
  '$provide', 'ORANGE_BASE_URL', 'ORANGE_API_URL', 'ORANGE_WS_URL', 'ORANGE_URL_SHORTENER',
  function ($provide, ORANGE_BASE_URL, ORANGE_API_URL, ORANGE_WS_URL, ORANGE_URL_SHORTENER) {

  var isOrange = window.location.hostname.indexOf('orange.fr') !== -1;
  if (isOrange) {
    $provide.constant('BASE_URL', ORANGE_BASE_URL);
    $provide.constant('API_URL', ORANGE_API_URL);
    $provide.constant('WS_URL', ORANGE_WS_URL);
    $provide.constant('URL_SHORTENER', ORANGE_URL_SHORTENER);
  }
}])

.factory('getSearchParameters', [
'$window',
function ($window) {
  'use strict';
  return function () {
    function transformToAssocArray(prmstr) {
      var params = {};
      var prmarr = prmstr.split('&');
      for (var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split('=');
        params[tmparr[0]] = tmparr[1];
      }
      return params;
    }



    var prmstr = $window.location.search.substr(1);
    return prmstr !== null && prmstr !== '' ? transformToAssocArray(prmstr) : {};
  };
}])

.run([
'DEBUG',
'$log',
'$rootScope',
'CommentService',
'Perfs',
function (DEBUG, $log, $rootScope, CommentService, Perfs) {
  'use strict';
  // Disable all log when production
  if (!DEBUG) {
    $log.log = angular.noop;
    $log.error = angular.noop;
    $log.info = angular.noop;
    $log.warn = angular.noop;
  }
  Perfs.init();
  $('[data-gc-loader]').remove();

  CommentService.countComments().success(function(resp) {
    // hide loader if no comments
    $rootScope.empty = (resp.count === 0);
  });
}]);
